'use strict';

var Radio = require('backbone.radio');
var Marionette = require('backbone.marionette');
var moment = require('moment-timezone');

var View = require('./list-item').default;
var EmptyView = require('./list-empty').default;
var GroupAppointmentCollection = require('../../collections/group-appointments').default;

export default Marionette.CollectionView.extend({

  className: '.group-appointment-list',
  tagName: 'ul',
  childView: View,
  emptyView: EmptyView,

  childViewOptions: function () {
    const timezone = window.localStorage.getItem('timezone');

    return {
      staff: this.staff,
      timezone: moment.tz(timezone).zoneAbbr(),
    };
  },

  childViewEvents: {
    'click:appointment': 'onClickAppointment',
  },

  initialize: function () {
    this.appointment = this.options.appointment;
    this.staff = this.options.staff;
    this.start = moment();
  },

  onDomRefresh: function () {
    if (this.appointment.has('id')) {
      var self = this;
      this.children.each(function (child) {
        if (child.model.get('id') == self.appointment.get('id')) {
          child.select();
        }
      });
    }
  },

  onClickAppointment: function (view) {
    this.deselectAll();
    view.select();

    this.appointment.set('id', view.model.get('id'));
    if (view.model.has('staff_id')) {
      var staff = this.staff.get(view.model.get('staff_id'));

      if (staff) {
        this.appointment.setStaff(staff);
      }
    }
    this.appointment.set('start', view.model.get('start'));
    this.appointment.set('type', window.CONSTANTS.APPT_TYPE_CLIENT_GROUP);
    this.appointment.set('attendee_count', view.model.get('attendee_count'));
    this.appointment.set('attendee_limit', view.model.get('attendee_limit'));
  },

  deselectAll: function () {
    this.$('.group-appointment-list-item').removeClass('active');
  },

  fetchTimes: async function (staff) {
    const self = this;

    self.trigger('showLoadingView');
    this.collection.fetch({
      data: self.getFetchParameters(staff),
      reset: true,
      success: function () {
        window.localStorage.removeItem('previous_timezone');
        self.collection = new GroupAppointmentCollection(
          self.collection.adjustWithTimezone(self.appointment),
        );
        self.trigger('hideLoadingView');
        self.render();
      },
      error: function () {
        self.trigger('hideLoadingView');
      },
    });
  },

  getFetchParameters: function (staff) {
    var shortcuts = [
      ...(window.LOCATION ? [window.CONSTANTS.LOCATION] : []),
      ...(window.SERVICE ? [window.CONSTANTS.SERVICE] : []),
      ...(window.STAFF ? [window.CONSTANTS.STAFF] : []),
    ];

    var parameters = {
      location_id: this.appointment.get('location_id'),
      service_id: this.appointment.get('service_id'),
      preferred: false,
      start: this.start.format('YYYY-MM-DD'),
      limit: 1000,
      group: true,
      ...(shortcuts.length ? { shortcuts } : {}),
    };

    if (staff && staff.id) {
      parameters.staff_id = staff.id;
      parameters.preferred = true;
    }

    return parameters;
  },

  setCollection: function (collection) {
    this.collection = collection;
  },

});
